"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ELEMENT_H1: function ELEMENT_H1() {
    return _ELEMENT_H;
  },
  ELEMENT_H2: function ELEMENT_H2() {
    return _ELEMENT_H2;
  },
  ELEMENT_H3: function ELEMENT_H3() {
    return _ELEMENT_H3;
  },
  ELEMENT_H4: function ELEMENT_H4() {
    return _ELEMENT_H4;
  },
  ELEMENT_H5: function ELEMENT_H5() {
    return _ELEMENT_H5;
  },
  ELEMENT_H6: function ELEMENT_H6() {
    return _ELEMENT_H6;
  },
  ELEMENT_TOC: function ELEMENT_TOC() {
    return _ELEMENT_TOC;
  },
  KEYS_HEADING: function KEYS_HEADING() {
    return _KEYS_HEADING;
  },
  KEY_HEADING: function KEY_HEADING() {
    return _KEY_HEADING;
  },
  checkIn: function checkIn() {
    return _checkIn;
  },
  createHeadingPlugin: function createHeadingPlugin() {
    return _createHeadingPlugin;
  },
  createTocPlugin: function createTocPlugin() {
    return _createTocPlugin;
  },
  getHeadingList: function getHeadingList() {
    return _getHeadingList;
  },
  heightToTop: function heightToTop() {
    return _heightToTop;
  },
  insertToc: function insertToc() {
    return _insertToc;
  },
  isHeading: function isHeading() {
    return _isHeading;
  },
  useContentController: function useContentController() {
    return _useContentController;
  },
  useTocController: function useTocController() {
    return _useTocController;
  },
  useTocElement: function useTocElement() {
    return _useTocElement;
  },
  useTocElementState: function useTocElementState() {
    return _useTocElementState;
  },
  useTocSideBar: function useTocSideBar() {
    return _useTocSideBar;
  },
  useTocSideBarState: function useTocSideBarState() {
    return _useTocSideBarState;
  }
});
module.exports = __toCommonJS(src_exports);

// src/heading/constants.ts
var _ELEMENT_H = "h1";
var _ELEMENT_H2 = "h2";
var _ELEMENT_H3 = "h3";
var _ELEMENT_H4 = "h4";
var _ELEMENT_H5 = "h5";
var _ELEMENT_H6 = "h6";
var _KEYS_HEADING = [_ELEMENT_H, _ELEMENT_H2, _ELEMENT_H3, _ELEMENT_H4, _ELEMENT_H5, _ELEMENT_H6];

// src/heading/createHeadingPlugin.ts
var import_server = require("@udecode/plate-common/server");
var _KEY_HEADING = "heading";
var _createHeadingPlugin = (0, import_server.createPluginFactory)({
  key: _KEY_HEADING,
  options: {
    levels: [1, 2, 3, 4, 5, 6]
  },
  then: function then(editor, _ref) {
    var _ref$options = _ref.options;
    _ref$options = _ref$options === void 0 ? {} : _ref$options;
    var levels = _ref$options.levels;
    var plugins = [];
    var headingLevels = Array.isArray(levels) ? levels : Array.from({
      length: levels || 6
    }, function (_, i) {
      return i + 1;
    });
    headingLevels.forEach(function (level) {
      var key = _KEYS_HEADING[level - 1];
      var plugin = {
        deserializeHtml: {
          rules: [{
            validNodeName: "H".concat(level)
          }]
        },
        handlers: {
          onKeyDown: import_server.onKeyDownToggleElement
        },
        isElement: true,
        key: key,
        options: {}
      };
      if (level < 4) {
        plugin.options.hotkey = ["mod+opt+".concat(level), "mod+shift+".concat(level)];
      }
      plugins.push(plugin);
    });
    return {
      plugins: plugins
    };
  }
});

// src/toc/createTocPlugin.ts
var import_plate_common = require("@udecode/plate-common");
var _ELEMENT_TOC = "toc";
var _createTocPlugin = (0, import_plate_common.createPluginFactory)({
  isElement: true,
  isVoid: true,
  key: _ELEMENT_TOC
});

// src/toc/hooks/useTocElement.ts
var import_react = __toESM(require("react"));
var import_plate_common3 = require("@udecode/plate-common");

// src/utils/checkIn.ts
function _checkIn(e) {
  var event = window.event;
  var x = Number(event.clientX);
  var y = Number(event.clientY);
  var ele = e.target;
  var div_x = Number(ele.getBoundingClientRect().left);
  var div_x_width = Number(ele.getBoundingClientRect().left + ele.clientWidth);
  var div_y = Number(ele.getBoundingClientRect().top);
  var div_y_height = Number(ele.getBoundingClientRect().top + ele.clientHeight);
  if (x > div_x && x < div_x_width && y > div_y && y < div_y_height) {
    return true;
  }
  return false;
}

// src/utils/getHeadingList.ts
var import_plate_common2 = require("@udecode/plate-common");

// src/utils/isHeading.ts
var _isHeading = function _isHeading(node) {
  return node.type && _KEYS_HEADING.includes(node.type);
};

// src/utils/getHeadingList.ts
var headingDepth = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _ELEMENT_H, 1), _ELEMENT_H2, 2), _ELEMENT_H3, 3), _ELEMENT_H4, 4), _ELEMENT_H5, 5), _ELEMENT_H6, 6);
var _getHeadingList = function _getHeadingList(editor) {
  var headingList = [];
  var values = (0, import_plate_common2.getNodeEntries)(editor, {
    at: [],
    match: function match(n) {
      return _isHeading(n);
    }
  });
  if (!values) return [];
  Array.from(values, function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      node = _ref3[0],
      path = _ref3[1];
    var type = node.type;
    var title = (0, import_plate_common2.getNodeString)(node);
    var depth = headingDepth[type];
    var id = node.id;
    title && headingList.push({
      depth: depth,
      id: id,
      path: path,
      title: title,
      type: type
    });
  });
  return headingList;
};

// src/utils/heightToTop.ts
var _heightToTop = function _heightToTop(ele, editorContentRef) {
  var root = editorContentRef ? editorContentRef.current : document.body;
  if (!root || !ele) return 0;
  var containerRect = root.getBoundingClientRect();
  var elementRect = ele.getBoundingClientRect();
  var scrollY = root.scrollTop;
  var absoluteElementTop = elementRect.top + scrollY - containerRect.top;
  return absoluteElementTop;
};

// src/toc/hooks/useTocElement.ts
var _useTocElementState = function _useTocElementState(_ref4) {
  var isScroll = _ref4.isScroll,
    topOffset = _ref4.topOffset;
  var headingList = (0, import_plate_common3.useEditorSelector)(_getHeadingList, []);
  var editor = (0, import_plate_common3.useEditorRef)();
  var containerRef = import_react.default.useRef(null);
  (0, import_react.useEffect)(function () {
    var container = (0, import_plate_common3.toDOMNode)(editor, editor);
    if (!container) return;
    containerRef.current = container;
    return function () {
      containerRef.current = null;
    };
  }, [editor]);
  var onContentScroll = import_react.default.useCallback(function (el, id) {
    var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "instant";
    var _a;
    if (!containerRef.current) return;
    if (isScroll) {
      (_a = containerRef.current) == null ? void 0 : _a.scrollTo({
        behavior: behavior,
        top: _heightToTop(el, containerRef) - topOffset
      });
    } else {
      var top = _heightToTop(el) - topOffset;
      window.scrollTo({
        behavior: behavior,
        top: top
      });
    }
    setTimeout(function () {
      (0, import_plate_common3.addSelectedRow)(editor, id);
    }, 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isScroll, topOffset]);
  return {
    editor: editor,
    headingList: headingList,
    onContentScroll: onContentScroll
  };
};
var _useTocElement = function _useTocElement(_ref5) {
  var editor = _ref5.editor,
    onContentScroll = _ref5.onContentScroll;
  return {
    props: {
      onClick: function onClick(e, item, behavior) {
        e.preventDefault();
        var id = item.id,
          path = item.path;
        var node = (0, import_plate_common3.getNode)(editor, path);
        if (!node) return;
        var el = (0, import_plate_common3.toDOMNode)(editor, node);
        if (!el) return;
        onContentScroll(el, id, behavior);
      }
    }
  };
};

// src/toc/tocSideBar/useContentController.ts
var import_react3 = __toESM(require("react"));
var import_plate_common5 = require("@udecode/plate-common");

// src/toc/tocSideBar/useContentObserver.ts
var import_react2 = __toESM(require("react"));
var import_plate_common4 = require("@udecode/plate-common");
var useContentObserver = function useContentObserver(_ref6) {
  var editorContentRef = _ref6.editorContentRef,
    isObserve = _ref6.isObserve,
    isScroll = _ref6.isScroll,
    rootMargin = _ref6.rootMargin,
    status = _ref6.status;
  var headingElementsRef = import_react2.default.useRef({});
  var root = isScroll ? editorContentRef.current : void 0;
  var editor = (0, import_plate_common4.useEditorRef)();
  var headingList = (0, import_plate_common4.useEditorSelector)(_getHeadingList, []);
  var _import_react2$defaul = import_react2.default.useState(""),
    _import_react2$defaul2 = _slicedToArray(_import_react2$defaul, 2),
    activeId = _import_react2$defaul2[0],
    setActiveId = _import_react2$defaul2[1];
  import_react2.default.useEffect(function () {
    var callback = function callback(headings) {
      if (!isObserve) return;
      headingElementsRef.current = headings.reduce(function (map, headingElement) {
        map[headingElement.target.id] = headingElement;
        return map;
      }, headingElementsRef.current);
      var visibleHeadings = [];
      Object.keys(headingElementsRef.current).forEach(function (key) {
        var headingElement = headingElementsRef.current[key];
        if (headingElement.isIntersecting) visibleHeadings.push(key);
      });
      var lastKey = Object.keys(headingElementsRef.current).pop();
      visibleHeadings.length > 0 && setActiveId(visibleHeadings[0] || lastKey);
      headingElementsRef.current = {};
    };
    var observer = new IntersectionObserver(callback, {
      root: root,
      rootMargin: rootMargin
    });
    headingList.forEach(function (item) {
      var path = item.path;
      var node = (0, import_plate_common4.getNode)(editor, path);
      if (!node) return;
      var element = (0, import_plate_common4.toDOMNode)(editor, node);
      return element && observer.observe(element);
    });
    return function () {
      observer.disconnect();
    };
  }, [headingList, isObserve, editor, root, rootMargin, status]);
  return {
    activeId: activeId
  };
};

// src/toc/tocSideBar/useContentController.ts
var _useContentController = function _useContentController(_ref7) {
  var containerRef = _ref7.containerRef,
    isObserve = _ref7.isObserve,
    rootMargin = _ref7.rootMargin,
    topOffset = _ref7.topOffset;
  var _a, _b;
  var editor = (0, import_plate_common5.useEditorRef)();
  var _import_react3$defaul = import_react3.default.useState(containerRef),
    _import_react3$defaul2 = _slicedToArray(_import_react3$defaul, 2),
    editorContentRef = _import_react3$defaul2[0],
    setEditorContentRef = _import_react3$defaul2[1];
  var isScrollRef = import_react3.default.useRef(false);
  var isScroll = (((_a = editorContentRef.current) == null ? void 0 : _a.scrollHeight) || 0) > (((_b = editorContentRef.current) == null ? void 0 : _b.clientHeight) || 0);
  isScrollRef.current = isScroll;
  var scrollContainer = import_react3.default.useMemo(function () {
    if (typeof window !== "object") return;
    return isScroll ? editorContentRef.current : window;
  }, [isScroll]);
  var _import_react3$defaul3 = import_react3.default.useState(0),
    _import_react3$defaul4 = _slicedToArray(_import_react3$defaul3, 2),
    status = _import_react3$defaul4[0],
    setStatus = _import_react3$defaul4[1];
  var _useContentObserver = useContentObserver({
      editorContentRef: editorContentRef,
      isObserve: isObserve,
      isScroll: isScroll,
      rootMargin: rootMargin,
      status: status
    }),
    activeId = _useContentObserver.activeId;
  var _import_react3$defaul5 = import_react3.default.useState(activeId),
    _import_react3$defaul6 = _slicedToArray(_import_react3$defaul5, 2),
    activeContentId = _import_react3$defaul6[0],
    setActiveContentId = _import_react3$defaul6[1];
  var onContentScroll = function onContentScroll(_ref8) {
    var _ref8$behavior = _ref8.behavior,
      behavior = _ref8$behavior === void 0 ? "instant" : _ref8$behavior,
      el = _ref8.el,
      id = _ref8.id;
    var _a2;
    setActiveContentId(id);
    if (isScrollRef.current) {
      (_a2 = editorContentRef.current) == null ? void 0 : _a2.scrollTo({
        behavior: behavior,
        top: _heightToTop(el, editorContentRef) - topOffset
      });
    } else {
      var top = _heightToTop(el) - topOffset;
      window.scrollTo({
        behavior: behavior,
        top: top
      });
    }
    (0, import_plate_common5.addSelectedRow)(editor, id);
  };
  import_react3.default.useEffect(function () {
    setEditorContentRef(containerRef);
  }, [containerRef]);
  import_react3.default.useEffect(function () {
    setActiveContentId(activeId);
  }, [activeId]);
  import_react3.default.useEffect(function () {
    if (!scrollContainer) return;
    var scroll = function scroll() {
      if (isObserve) {
        setStatus(Date.now());
      }
    };
    scrollContainer.addEventListener("scroll", scroll);
    return function () {
      scrollContainer.removeEventListener("scroll", scroll);
    };
  }, [isObserve, scrollContainer]);
  return {
    activeContentId: activeContentId,
    onContentScroll: onContentScroll
  };
};

// src/toc/tocSideBar/useTocController.ts
var import_react5 = __toESM(require("react"));

// src/toc/tocSideBar/useTocObserver.ts
var import_react4 = __toESM(require("react"));
var useTocObserver = function useTocObserver(_ref9) {
  var activeId = _ref9.activeId,
    isObserve = _ref9.isObserve,
    showHeader = _ref9.showHeader,
    tocRef = _ref9.tocRef;
  var root = tocRef.current;
  var _import_react4$defaul = import_react4.default.useState(true),
    _import_react4$defaul2 = _slicedToArray(_import_react4$defaul, 2),
    visible = _import_react4$defaul2[0],
    setVisible = _import_react4$defaul2[1];
  var _import_react4$defaul3 = import_react4.default.useState(0),
    _import_react4$defaul4 = _slicedToArray(_import_react4$defaul3, 2),
    offset = _import_react4$defaul4[0],
    setOffset = _import_react4$defaul4[1];
  import_react4.default.useEffect(function () {
    var callback = function callback(entries) {
      if (!isObserve) return;
      var entry = entries[0];
      var isBelow = entry.boundingClientRect.bottom > entry.rootBounds.bottom;
      var isAbove = entry.boundingClientRect.top < entry.rootBounds.top;
      var isVisible = entry.intersectionRatio === 1;
      if (isVisible) {
        setVisible(true);
      } else {
        setVisible(false);
        if (isAbove) {
          setOffset(entry.boundingClientRect.top - entry.rootBounds.top);
        }
        if (isBelow) {
          setOffset(entry.boundingClientRect.bottom - entry.rootBounds.bottom);
        }
      }
    };
    var observer = new IntersectionObserver(callback, {
      root: root
    });
    var element = document.querySelectorAll("#toc_item_active")[0];
    if (element) observer.observe(element);
    return function () {
      observer.disconnect();
    };
  }, [activeId, root, isObserve, showHeader]);
  return {
    offset: offset,
    visible: visible
  };
};

// src/toc/tocSideBar/useTocController.ts
var _useTocController = function _useTocController(_ref10) {
  var activeId = _ref10.activeId,
    isObserve = _ref10.isObserve,
    showHeader = _ref10.showHeader,
    tocRef = _ref10.tocRef;
  var _import_react5$defaul = import_react5.default.useState(""),
    _import_react5$defaul2 = _slicedToArray(_import_react5$defaul, 2),
    activeTocId = _import_react5$defaul2[0],
    setActiveTocId = _import_react5$defaul2[1];
  var _useTocObserver = useTocObserver({
      activeId: activeTocId,
      isObserve: isObserve,
      showHeader: showHeader,
      tocRef: tocRef
    }),
    offset = _useTocObserver.offset,
    visible = _useTocObserver.visible;
  import_react5.default.useEffect(function () {
    var _a;
    if (!visible) {
      var tocItemWrapper = (_a = tocRef.current) == null ? void 0 : _a.querySelector("#toc_wrap");
      var top = (tocItemWrapper == null ? void 0 : tocItemWrapper.scrollTop) + offset;
      tocItemWrapper == null ? void 0 : tocItemWrapper.scrollTo({
        behavior: "instant",
        top: top
      });
    }
  }, [visible, offset, tocRef]);
  import_react5.default.useEffect(function () {
    setActiveTocId(activeId);
  }, [activeId]);
};

// src/toc/tocSideBar/useTocSideBarState.ts
var import_react6 = __toESM(require("react"));
var import_plate_common6 = require("@udecode/plate-common");
var _useTocSideBarState = function _useTocSideBarState(_ref11) {
  var containerRef = _ref11.containerRef,
    onOpenChange = _ref11.onOpenChange,
    _ref11$open = _ref11.open,
    open = _ref11$open === void 0 ? true : _ref11$open,
    _ref11$rootMargin = _ref11.rootMargin,
    rootMargin = _ref11$rootMargin === void 0 ? "0px 0px 0px 0px" : _ref11$rootMargin,
    _ref11$showHeader = _ref11.showHeader,
    showHeader = _ref11$showHeader === void 0 ? true : _ref11$showHeader,
    style = _ref11.style,
    _ref11$topOffset = _ref11.topOffset,
    topOffset = _ref11$topOffset === void 0 ? 0 : _ref11$topOffset;
  var editor = (0, import_plate_common6.useEditorRef)();
  var headingList = (0, import_plate_common6.useEditorSelector)(_getHeadingList, []);
  var tocRef = import_react6.default.useRef(null);
  var _import_react6$defaul = import_react6.default.useState(false),
    _import_react6$defaul2 = _slicedToArray(_import_react6$defaul, 2),
    mouseInToc = _import_react6$defaul2[0],
    setMouseInToc = _import_react6$defaul2[1];
  var _import_react6$defaul3 = import_react6.default.useState(open),
    _import_react6$defaul4 = _slicedToArray(_import_react6$defaul3, 2),
    isObserve = _import_react6$defaul4[0],
    setIsObserve = _import_react6$defaul4[1];
  var _useContentController2 = _useContentController({
      containerRef: containerRef,
      isObserve: isObserve,
      rootMargin: rootMargin,
      topOffset: topOffset
    }),
    activeContentId = _useContentController2.activeContentId,
    onContentScroll = _useContentController2.onContentScroll;
  _useTocController({
    activeId: activeContentId,
    isObserve: isObserve,
    showHeader: showHeader,
    tocRef: tocRef
  });
  return {
    activeContentId: activeContentId,
    editor: editor,
    headingList: headingList,
    mouseInToc: mouseInToc,
    onContentScroll: onContentScroll,
    onOpenChange: onOpenChange,
    open: open,
    setIsObserve: setIsObserve,
    setMouseInToc: setMouseInToc,
    showHeader: showHeader,
    style: style,
    tocRef: tocRef
  };
};
var _useTocSideBar = function _useTocSideBar(_ref12) {
  var editor = _ref12.editor,
    mouseInToc = _ref12.mouseInToc,
    onContentScroll = _ref12.onContentScroll,
    open = _ref12.open,
    setIsObserve = _ref12.setIsObserve,
    setMouseInToc = _ref12.setMouseInToc,
    tocRef = _ref12.tocRef;
  import_react6.default.useEffect(function () {
    if (mouseInToc) {
      setIsObserve(false);
    } else {
      setIsObserve(true);
    }
  }, [mouseInToc]);
  var onContentClick = import_react6.default.useCallback(function (e, item, behavior) {
    e.preventDefault();
    var id = item.id,
      path = item.path;
    var node = (0, import_plate_common6.getNode)(editor, path);
    if (!node) return;
    var el = (0, import_plate_common6.toDOMNode)(editor, node);
    if (!el) return;
    onContentScroll({
      behavior: behavior,
      el: el,
      id: id
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return {
    navProps: {
      onMouseEnter: function onMouseEnter() {
        !mouseInToc && open && setMouseInToc(true);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (open) {
          var isIn = _checkIn(e);
          isIn !== mouseInToc && setMouseInToc(isIn);
        }
      },
      ref: tocRef
    },
    onContentClick: onContentClick
  };
};

// src/toc/transforms/insertToc.ts
var import_plate_common7 = require("@udecode/plate-common");
var _insertToc = function _insertToc(editor, options) {
  (0, import_plate_common7.insertNodes)(editor, {
    children: [{
      text: ""
    }],
    type: _ELEMENT_TOC
  }, options);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ELEMENT_H1: _ELEMENT_H,
  ELEMENT_H2: _ELEMENT_H2,
  ELEMENT_H3: _ELEMENT_H3,
  ELEMENT_H4: _ELEMENT_H4,
  ELEMENT_H5: _ELEMENT_H5,
  ELEMENT_H6: _ELEMENT_H6,
  ELEMENT_TOC: _ELEMENT_TOC,
  KEYS_HEADING: _KEYS_HEADING,
  KEY_HEADING: _KEY_HEADING,
  checkIn: _checkIn,
  createHeadingPlugin: _createHeadingPlugin,
  createTocPlugin: _createTocPlugin,
  getHeadingList: _getHeadingList,
  heightToTop: _heightToTop,
  insertToc: _insertToc,
  isHeading: _isHeading,
  useContentController: _useContentController,
  useTocController: _useTocController,
  useTocElement: _useTocElement,
  useTocElementState: _useTocElementState,
  useTocSideBar: _useTocSideBar,
  useTocSideBarState: _useTocSideBarState
});